import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';
import { validateClubId } from '@utils/formValidations';

import { ClubCreateFormValues } from '@features/club/ui/ClubCreateForm';

export function ClubIdInput() {
  const { control } = useFormContext<ClubCreateFormValues>();
  return (
    <FormRow>
      <FormLabel hint="Допустимы только строчные латинские буквы, цифры и дефис">
        ID клуба
      </FormLabel>
      <FormInput>
        <Controller
          name="clubId"
          control={control}
          rules={{
            required: true,
            validate: validateClubId,
          }}
          render={({ field: { value, onChange, disabled }, fieldState }) => (
            <Input
              value={value as string}
              onChange={onChange}
              disabled={disabled}
              error={Boolean(fieldState.error)}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
